import { FC, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { QueryParamsProps } from '@/components/api/ApiQuery'
import { ListInfiniteScroll } from '@/components/common/list'
import { ListOrderEmpty } from '@/components/common/list/empty'
import { ListItemOrder } from '@/components/domains/listItems'
import OneOnOneInquiryButton from '@/components/domains/order/OneOnOneInquiryButton'
import { PageSizeEnum } from '@/constants/page-size.enum'
import { useTracker } from '@/containers/contexts/EventTrackingProvider'
import useProduct from '@/containers/hooks/useProduct'
import { doSetToggleRefetchOrderList } from '@/stores/reduxData'
import { RootState } from '@/stores/store'
import { FitpetMallEventEnum } from '@/utils/event-tracker/events'
import { addDay, DATE_FORMAT_YYYY_MM_DD } from '@/utils/utilDate'

const ListOrdersHistory: FC = () => {
  const dispatch = useDispatch()
  const tracker = useTracker()
  const refetchRef = useRef<any>()
  const shouldRefetch = useSelector((rootState: RootState) => rootState.reduxDataReducers.shouldRefetchOrderList)
  const [forceRerender, toggleForceRerender] = useState<boolean>(false)
  const [filterPeriod, setfilterPeriod] = useState<string | undefined>(addDay(-183, undefined, DATE_FORMAT_YYYY_MM_DD))

  useEffect(() => {
    if (forceRerender) {
      toggleForceRerender(false)
    }
  }, [forceRerender])

  useEffect(() => {
    toggleForceRerender(true)
  }, [filterPeriod])

  useEffect(() => {
    if (shouldRefetch) {
      dispatch(doSetToggleRefetchOrderList(false))
      toggleForceRerender(true)
    }
  }, [shouldRefetch])

  useEffect(() => {
    tracker.triggerCustomEvent(FitpetMallEventEnum.ViewOrderlist)
  }, [])

  const queryParams: QueryParamsProps = {
    gqlKey: 'ordersHistory',
    dataKey: 'orders',
    variables: {
      filter: {
        orderBy: '-id',
        createdAtAfter: filterPeriod,
      },
    },
  }

  // 장바구니 로직은 따로 작성합니다.
  const { queryAddCartItemForOrderHistory } = useProduct()

  const handleAddCartOrderItem = async (quantity: number, productOptionId: string, productPromotionId?: string) => {
    await queryAddCartItemForOrderHistory(quantity, productOptionId, productPromotionId)
  }

  return (
    <>
      {!forceRerender && (
        <StyledWrapper>
          <ListInfiniteScroll
            noCache
            refetchRef={refetchRef}
            defaultPageSize={PageSizeEnum.PageSize10}
            queryParams={queryParams}
            grid={1}
            filterPeriod={filterPeriod}
            changePeriod={setfilterPeriod}
            renderItem={(item) => <ListItemOrder order={item} handleAddCartOrderItem={handleAddCartOrderItem} />}
            emptyText={<ListOrderEmpty type={'order'} />}
          />
        </StyledWrapper>
      )}
      <OneOnOneInquiryButton />
    </>
  )
}

const StyledWrapper = styled.div``

export default ListOrdersHistory
